"use client"

import {
    filterSeasonalMerchandiseProductsByVariantDisplays,
    type VariantSortPreference
} from "@/app/(site)/_utils/seasonalMerchandising"
import type { Locale } from "@/i18n/locales"
import depictListingClient from "@/lib/depict-client/depict-listing-client-init"
import {
    type CurrencyFormat,
    formatDepictPrices,
    transformDepictToProductData
} from "@/lib/depict-client/helpers/depict-transforms"
import { type SortModel } from "@/lib/depict-client/types/api/ProductListingRequestV3"
import logger from "@/lib/logger/logger-init"
import { match } from "ts-pattern"

export const getDepictProductsInListingViaExternalIdClient = async (config: {
    market: string
    locale: string
    external_id?: string
    limit?: number
    page?: number
    cursor?: string | undefined
    hits_per_page?: number
    filters: any
    session_id?: string
    sort?: SortModel
    basketSessionCurrencyFormat: CurrencyFormat | undefined
    paramsLocale: Locale
    sortPreference?: VariantSortPreference
}) => {
    // Fetch the price formatting data from cookies
    const currentPricelist = config.basketSessionCurrencyFormat
    const request = await depictListingClient.listing.getProductsInListingViaExternalId(
        config?.external_id ?? "",
        {
            market: config.market,
            locale: config.locale,
            limit: config.limit,
            cursor: config.cursor,
            filters: config.filters,
            session_id: config.session_id, // Look into this and apply it if needed
            sort: config.sort
        }
    )

    return match(request)
        .with({ success: true }, async data => {
            // Transform the raw data
            const transformedDataWithFormattedPrices = formatDepictPrices(
                data.data,
                currentPricelist,
                true
            )

            const finalResponse = config.locale
                ? {
                      ...transformedDataWithFormattedPrices,
                      displays: filterSeasonalMerchandiseProductsByVariantDisplays(
                          transformedDataWithFormattedPrices.displays,
                          config.paramsLocale,
                          config.sortPreference
                      )
                  }
                : transformedDataWithFormattedPrices

            const products = transformDepictToProductData(finalResponse, "item_group_id")

            return { ...finalResponse, products }
        })
        .with({ success: false }, ({ error }) => {
            logger.error(
                "Failed response fetching products via in Client 'getProductsInListingViaExternalId' from Depict",
                error
            )
            return {
                displays: [],
                products: [],
                cursor: undefined,
                n_hits: 0,
                filters: []
            }
        })
        .exhaustive()
}
